import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpService } from '../http.service';
import { HttpRequestHandler } from '../../models/http-model';
const HEADERS = {};
@Injectable()
export class DocumentService {
  static ENV = environment;

  constructor(private httpService: HttpService) {
    HEADERS['Content-Type'] = 'application/json';
   }

  public lovsWS(data, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(`${DocumentService.ENV.environment.API.lovs_ws}`, data, httpRequesthandler);
  }

  public getProviders(httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(`${DocumentService.ENV.environment.API.lovs_ws}`, httpRequesthandler);
  }

  public getLookupValueDOEQ(data: any , httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(`${DocumentService.ENV.environment.API.get_lookup_values_DOEQ}`, data, httpRequesthandler);
  }

  public getDataProviderDOEQ(httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(DocumentService.ENV.environment.API.get_providers_DOEQ, httpRequesthandler);
  }

  public getProcessId(httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(DocumentService.ENV.environment.API.get_sequence_process, httpRequesthandler);
  }

  public proccessSave(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(DocumentService.ENV.environment.API.process_DOEQ, data, httpRequesthandler);
  }

  public getListProccess(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(DocumentService.ENV.environment.API.get_proccess_DOEQ, data, httpRequesthandler);
  }
  public getListProccesP(param: string, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(`${DocumentService.ENV.environment.API.get_proccess_DOEQ}/${param}`, httpRequesthandler);
  }

  public updateProccess(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.put(DocumentService.ENV.environment.API.process_DOEQ, data, httpRequesthandler);
  }
  public getFileName(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(DocumentService.ENV.environment.API.get_file_name, data, httpRequesthandler);
  }

  public automaticFileUpload(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(DocumentService.ENV.environment.API.automatic_file_upload, data, httpRequesthandler);
  }
  public automaticGeneration(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(DocumentService.ENV.environment.API.automatic_generation, data, httpRequesthandler);
  }
  public automaticGenerationDat(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(DocumentService.ENV.environment.API.automatic_generation_dat, data, httpRequesthandler);
  }
  
  public revokeTask(id: string, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.delete(`${DocumentService.ENV.environment.API.revoke_task_celery}/${id}`,  httpRequesthandler);
  }
  public getSupportDocu(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(DocumentService.ENV.environment.API.get_support_docu, data, httpRequesthandler);
  }
  public repDocSupport(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(DocumentService.ENV.environment.API.rep_doc_support, data, httpRequesthandler);
  }
  public deleteSupportDocu(item: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.delete(`${DocumentService.ENV.environment.API.get_support_docu}/${item.invoice_id}/${item.linea}`, httpRequesthandler);
  }
  public updateConsecutive(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(DocumentService.ENV.environment.API.generate_report, data, httpRequesthandler);
  }
  public generationConsecutive(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(DocumentService.ENV.environment.API.generate_consecutive, data, httpRequesthandler);
  }
  public getInfoReporte(httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(DocumentService.ENV.environment.API.get_info_reports, httpRequesthandler);
  }
  public getReportFactHist(invoice_id, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(`${DocumentService.ENV.environment.API.get_report_fact}/${invoice_id}`, httpRequesthandler);
  }
  public updateProccessStatus(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.put(DocumentService.ENV.environment.API.update_process_status, data, httpRequesthandler);
  }

  public generateFile(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(DocumentService.ENV.environment.API.generation_file, data, httpRequesthandler);
  }

  public getListFileName(httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(`${DocumentService.ENV.environment.API.get_filename}`, httpRequesthandler);
  }

  public getDocument(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(DocumentService.ENV.environment.API.get_document , data, httpRequesthandler);

  }

  public getInvoiceInProcess(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(DocumentService.ENV.environment.API.get_process_support_docu, data, httpRequesthandler);
  }

  public processSupportDocument(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(DocumentService.ENV.environment.API.generation_document, data, httpRequesthandler);
  }
  public settingsResolutionfindBy(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(DocumentService.ENV.environment.API.get_settings_resolution, data, httpRequesthandler);
  }
  public settingsResolutionRemove(id: number, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.delete(`${DocumentService.ENV.environment.API.settings_resolution}/${id}`, httpRequesthandler);
  }

  public settingsResolutionSave(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(DocumentService.ENV.environment.API.settings_resolution, data, httpRequesthandler);
  }

  public settingsResolutionUpdate(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.put(DocumentService.ENV.environment.API.settings_resolution, data, httpRequesthandler);
  }

  
  public settingsResolutionfindAll(httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(DocumentService.ENV.environment.API.settings_resolution, httpRequesthandler);
  }
  
  public setChangeCompany(data, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(`${DocumentService.ENV.environment.API.setChangeCompany}`, data, httpRequesthandler);
  }

  public getClients(httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(`${DocumentService.ENV.environment.API.get_clientes_cr}`, httpRequesthandler);
  }

  public getPayloadGetData(data: any,  httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(`${DocumentService.ENV.environment.API.get_payload_getdata}`, data, httpRequesthandler);
  }

  public getDataLedger(httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(`${DocumentService.ENV.environment.API.get_ledger}`, httpRequesthandler);
  }

  public getAgencies(httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(`${DocumentService.ENV.environment.API.agencies}`, httpRequesthandler);
  }
  public getTipDocResolution(httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(`${DocumentService.ENV.environment.API.view_tip_doc_resolution}`, httpRequesthandler)
  }

  public getClaTecResolution(httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(`${DocumentService.ENV.environment.API.view_cla_tec_resolution}`, httpRequesthandler)
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/document/document.service.ts